import React from 'react'
import PropTypes from 'prop-types'
import RangeSlider from 'components/RangeSlider'
import ContainerDimentionsContext from 'components/ContainerDimentionsContext'
import RangeSliderWithContext from 'components/RangeSlider/RangeSliderWithContext'
import ChannelGroupSelector from 'containers/ChannelGroupSelector'
import SelectGroup from 'components/SelectGroup'
import Icon from 'components/Icon'
import Loader from 'components/Loader'
import {channelGroupList, channelTypeList} from '@divvit/common-channels'
import partial from 'utils/partial'
import classnames from 'classnames'
import formatDate from 'date-fns/format'
import setHours from 'date-fns/set_hours'
import pluralize from 'pluralize'
import map from 'lodash/map'
import Checkbox from 'components/Checkbox'
import CountryMultiSelect from 'components/CountryMultiSelect'

const DAY = 24 * 60
const HOUR = 60

const touchpointsSections = [
  {
    key: 'first',
    title: 'First',
    type: 'channel'
  },
  {
    key: 'firstInterval',
    type: 'interval',
    align: 'center'
  },
  {
    key: 'second',
    title: 'Second',
    type: 'channel',
    align: 'center'
  },
  {
    key: 'includes',
    title: 'Includes',
    type: 'channel',
    align: 'center',
    borders: true
  },
  {
    key: 'penultimate',
    title: 'Before Last',
    type: 'channel',
    align: 'center'
  },
  {
    key: 'lastInterval',
    type: 'interval',
    align: 'center'
  },
  {
    key: 'last',
    title: 'Last',
    type: 'channel',
    align: 'right'
  },
  {
    key: 'hasImpression',
    title: 'has Impression',
    type: 'display',
    align: 'center',
    borders: true
  },
  {
    key: 'onlyRegFin',
    title: 'only Reg Fin',
    type: 'display',
    align: 'center'
  }
]

const filterItems = {
  orderTime: {
    title: 'Conversion Time',
    icon: 'time',
    type: 'slider',
    formatValue: value => formatDate(setHours(new Date(), value / 60), 'HH:00'),
    tooltip: (value, amount) => {
      const format = value => formatDate(setHours(new Date(), value / 60), 'HH:00')
      return `${amount} ${pluralize('conversion', amount)}${' '}
        ${pluralize('was', amount)} made between${' '}
        ${format(value)} and ${format(value + 60)}`
    }
  },
  // productCount: {
  //   title: 'Product Count',
  //   icon: 'product',
  //   type: 'slider',
  //   tooltip: (value, amount) => {
  //     return `${amount} ${pluralize('conversion', amount)}${' '}
  //      ${pluralize('have', amount)} ${value}${' '}
  //      ${pluralize('product', value)}`
  //   },
  //   limit: 1
  // },
  sessionCount: {
    title: 'Touchpoints Before Conversion',
    icon: 'visit',
    type: 'slider',
    tooltip: (value, amount) => {
      return `${amount} ${pluralize('conversion', amount)}${' '}
       ${pluralize('have', amount)} ${value}${' '}
       ${pluralize('visits', value)} before purchase`
    },
    limit: 1
  }
  // customerType: {
  //   title: 'Customer Type',
  //   icon: 'customer',
  //   type: 'select'
  // }
}

export default class OrdersFilter extends React.Component {
  static propTypes = {
    touchpoints: PropTypes.object,
    onFilterChange: PropTypes.func,
    onFilterReset: PropTypes.func,
    onTouchpointChange: PropTypes.func,
    filters: PropTypes.object,
    disabled: PropTypes.bool,
    sessionsOnly: PropTypes.bool,
    setSessionsOnly: PropTypes.func,
    countries: PropTypes.array,
  }

  static defaultProps = {
    touchpoints: {}
  }

  render() {
    const {onFilterReset, disabled, sessionsOnly, setSessionsOnly} = this.props

    const classNames = classnames('orders-filter', {
      'is-disabled': disabled
    })

    return (
      <div className={classNames}>
        <div className='orders-filter_header'>
          <div className='orders-filter_header_title'>Filters</div>
          {this.renderCountryFilters()}
          <div
            className='orders-filter_header_reset'
            onClick={onFilterReset}
          >
            Reset all
          </div>
        </div>
        <div className='orders-filter_filters'>
          {this.renderFilters()}
        </div>
        <div className='orders-filter_filters'>
          <div className='orders-filter_filter'>
            <div className='orders-filter_header is-dark'>
              <div className='orders-filter_header_title'>
                <span className='orders-filter_header_title_inner'>Touchpoint SEQUENCE</span>
                <div className='orders-filter_header_sessions_only'>
                  <span className='orders-filter_header_sessions_only_label'>Filter for Sessions Only</span>
                  <Checkbox
                    align='right'
                    color='default'
                    checked={sessionsOnly}
                    onChange={setSessionsOnly}
                  />
                </div>
              </div>
            </div>
            <div className='orders-filter_sequence'>
              {this.renderTouchpointSections()}
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderCountryFilters() {
    const {onFilterChange, countries} = this.props
    const data = this.getFiltersData('countries')
    return (
      <div className='orders-filter_header_country'>
        <CountryMultiSelect countries={countries} onChange={partial(onFilterChange, 'countries')} values={data} />
      </div>
    )
  }

  renderFilters() {
    return Object.keys(filterItems).map((filter, index) => {
      return this.renderFilter(filter, index)
    })
  }

  renderFilter(filter, index) {
    const {title, icon} = filterItems[filter]

    return (
      <div className='orders-filter_filter' key={index}>
        <div className='orders-filter_filter_title'>
          {this.renderFilterIcon(icon)}
          {title}
        </div>
        <div className='orders-filter_filter_body'>
          {this.renderFilterControl(filter)}
        </div>
      </div>
    )
  }

  renderFilterIcon(icon) {
    if (!icon) return null

    return (
      <Icon className='orders-filter_filter_title_icon' name={icon} size='14px' />
    )
  }

  renderFilterControl(filter) {
    const {onFilterChange, disabled} = this.props
    const {type, formatValue, limit, tooltip} = filterItems[filter]
    const data = this.getFiltersData(filter)

    if (!data) return <Loader />

    if (type === 'slider') {
      const {chartData, step, xAxisKey, dataKey, limits: {min, max}, values} = data

      return (
        <ContainerDimentionsContext className='orders-filter_slider'>
          <RangeSliderWithContext
            disabled={disabled}
            min={min}
            max={max}
            values={values}
            chartData={chartData}
            dataKey={dataKey}
            xAxisKey={xAxisKey}
            step={step}
            onSelect={partial(onFilterChange, filter)}
            formatValue={formatValue}
            tooltip={tooltip}
            limit={limit}
          />
        </ContainerDimentionsContext>
      )
    } else {
      return (
        <SelectGroup
          disabled={disabled}
          className='orders-filter_group'
          values={[
            {value: 'any', label: 'Any'},
            {value: 'new', label: 'New'},
            {value: 'repeat', label: 'Ret.'}
          ]}
          selected={data}
          onSelect={partial(onFilterChange, filter)}
        />
      )
    }
  }

  renderTouchpointSections() {
    return map(touchpointsSections, (section, index) => {
      return this.renderSection(section, index)
    })
  }

  renderSection(section, index) {
    const {title, align, borders} = section
    const classNames = classnames('orders-filter_sequence_item', {
      'is-left': align === 'left',
      'is-center': align === 'center',
      'is-right': align === 'right',
      'with-borders': borders
    })

    return (
      <div className={classNames} key={index}>
        <div className='orders-filter_sequence_item_title'>{title}</div>
        <div className='orders-filter_sequence_item_body'>
          {this.renderSectionControl(section)}
        </div>
      </div>
    )
  }

  renderSectionControl(section) {
    const {touchpoints, onTouchpointChange, disabled} = this.props
    const {type, key} = section
    const values = touchpoints[key]
    const types = touchpoints[key + 'ChannelTypes']

    if (type === 'channel') {
      return (
        <ChannelGroupSelector
          disabled={disabled}
          className='orders-filter_sequence_item_channel'
          groups={channelGroupList}
          channelTypes={channelTypeList}
          types={types}
          selected={values}
          onSelect={partial(onTouchpointChange, key)}
        />
      )
    } else if (type === 'display') {
      const classNames = classnames('channel-icon_icon', {
        [`channel-group-selector_any`]: !values
      })
      return (
        <div
          className='channel-group-selector is-empty'
          onClick={partial(onTouchpointChange, key, !values)}
        >
          <Icon
            disabled={disabled}
            className={classNames}
            name={`display-${key}`}
          />
        </div>
      )
    } else {
      return (
        <RangeSlider
          className='orders-filter_sequence_item_interval'
          title='Interval'
          disabled={disabled}
          min={0}
          max={30 * DAY}
          stepValues={[
            0, 5, 15, 30,
            1 * HOUR, 2 * HOUR, 5 * HOUR, 12 * HOUR,
            1 * DAY, 3 * DAY, 5 * DAY, 15 * DAY, 30 * DAY
          ]}
          values={values}
          showEmptyPlaceholders
          showClearIcon
          onSelect={partial(onTouchpointChange, key)}
          formatValue={value => {
            const days = Math.floor(value / DAY)
            const hours = Math.floor(value / HOUR)
            if (days) {
              return `${days}d`
            } else if (hours) {
              return `${hours}h`
            } else {
              return `${value}m`
            }
          }}
        />
      )
    }
  }

  getFiltersData(filter) {
    const {filters} = this.props

    if (!filters) return null

    return filters[filter]
  }
}



// WEBPACK FOOTER //
// ./client/views/OrdersInsightView/OrdersFilter.js